/** @jsx h */
import { h } from 'preact'

const HelpIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='16'
      viewBox='0 0 10 16'
    >
      <path
        fill='currentColor'
        d='M4.18 11.186l2.115-.698c-.333-.232-.523-.674-.523-1.046 0-2.07 4.228-2.349 4.228-5.79C10 1.557 8.171 0 5.178 0 3.04 0 1.211.837 0 2.302l1.615 1.745c.784-1 1.83-1.628 3.302-1.628 1.52 0 2.256.767 2.256 1.674 0 1.977-3.824 2.256-3.824 5.093 0 .767.261 1.465.832 2zM5.037 16c-.903 0-1.663-.767-1.663-1.651 0-.86.76-1.605 1.663-1.605.902 0 1.662.744 1.662 1.605 0 .884-.76 1.651-1.662 1.651z'
      />
    </svg>
  )
}

export default HelpIcon
